// ======================================================================
// File Name       : DistributionContentList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, InputGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import TableHead from '../TableHead';
import { getItemBoxName, WRONG_DISTRIBUTION_DATE_TXT } from '../../utils/index';
import { CONTENT_DISTRIBUTION_CONTENT_TYPE } from '../../constants/ContentDistributionConstant';
import DateTimeWithValidate from '../DateTimeWithValidate';
import DateTimeMinMax from '../DateTimeMinMax';
import { DEFAULT_DATE_FORMAT } from '../../constants/index';

class DistributionContentList extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
    this.handleDeleteDistribution = this.handleDeleteDistribution.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  handleDeleteDistribution(id, contentType) {
    this.props.handleDeleteDistribution(id, contentType);
  }
  render() {
    this.refsToValidate = [];
    const {
      existedContentListInfo,
      distributionContentList,
      handleDateTimeChange,
      handleDeleteDistribution,
    } = this.props;
    const thead = [
      { title: 'コンテンツ\n識別ID', sortBy: null},
      { title: 'コンテンツ種別', sortBy: null},
      { title: '配布コンテンツ名', sortBy: null },
      { title: '配布開始日', sortBy: null },
      { title: '配布終了日', sortBy: null },
      { title: '操作', sortBy: null},
    ];
    
    // table data
    let distributionTableData = null;
    if (distributionContentList) {
      distributionTableData = distributionContentList
        .map((distributiontData, index) => {
          const addNewClass = distributiontData.addedNew ?
            'background_new_record' : '';
          return (
            <tr
              key={index}
              className={addNewClass}
            >
              <td>
                {distributiontData.contentSecernId}
              </td>
              <td>
                {getItemBoxName(CONTENT_DISTRIBUTION_CONTENT_TYPE, distributiontData.contentType)}
              </td>
              <td>
                {distributiontData.contentName}
              </td>
              <td>
                <DateTimeWithValidate
                  dateFormat={DEFAULT_DATE_FORMAT}
                  value={distributiontData.distributionStartDate}
                  onChange={moment =>
                    handleDateTimeChange(
                      moment,
                      distributiontData.contentSecernId,
                      'distributionStartDate',
                      distributiontData.contentType,
                    )}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
                {(distributiontData.distributionStartDate === null ||
                  distributiontData.distributionStartDate === '') &&
                  <p className="alert alert-danger">配布開始日が入力されていません。</p>}
              </td>
              <td>
                <DateTimeWithValidate
                  dateFormat={DEFAULT_DATE_FORMAT}
                  value={distributiontData.distributionEndDate}
                  onChange={moment =>
                    handleDateTimeChange(
                      moment,
                      distributiontData.contentSecernId,
                      'distributionEndDate',
                      distributiontData.contentType,
                    )}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
                <DateTimeMinMax
                  dateFrom={distributiontData.distributionStartDate}
                  dateTo={distributiontData.distributionEndDate}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  wrongPeriodTxt={WRONG_DISTRIBUTION_DATE_TXT}
                />
                {(distributiontData.distributionEndDate === null ||
                  distributiontData.distributionEndDate === '') &&
                  <p className="alert alert-danger">配布終了日が入力されていません。</p>}
              </td>
              <td className="text-center">
                <i
                  role="button"
                  id={distributiontData.contentSecernId}
                  onClick={this.handleDeleteDistribution.bind(this, distributiontData.contentSecernId, distributiontData.contentType)}
                  className="bi bi-trash padding-top-10"
                />
              </td>
            </tr>);
        },
        );
    }

    return (
      <Table striped hover className="margin-top-10">
        <thead>
          <TableHead data={thead} />
        </thead>
        <tbody>
          {distributionTableData}
        </tbody>
      </Table>
    );
  }
}

export default DistributionContentList;
